"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var TripPilgrimJoinRequestAction = /** @class */ (function (_super) {
    __extends(TripPilgrimJoinRequestAction, _super);
    function TripPilgrimJoinRequestAction() {
        var _this = _super.call(this) || this;
        _this.message = '';
        _this.loader = false;
        _this.loaderForm = false;
        _this.existingJoinRequest = null;
        _this.formHasErrors = false;
        _this.formErrorMessage = null;
        _this.hasSession = false;
        return _this;
    }
    TripPilgrimJoinRequestAction.prototype.mounted = function () {
        var _this = this;
        this.hasSession = this.$oAuth2.getSessionId() !== null;
        this.$root.$on('AUTHENTICATED_EVENT', function () {
            _this.hasSession = true;
        });
    };
    TripPilgrimJoinRequestAction.prototype.onSubmit = function () {
        var _this = this;
        this.formHasErrors = false;
        this.loaderForm = true;
        var joinRequest = {
            message: this.message,
            trip_pilgrim: { id: this.tripPilgrim.id }
        };
        this.$createTripPilgrimJoinRequestService.request(joinRequest).then(function () {
            _this.loaderForm = false;
            _this.message = '';
            _this.$bvModal.hide('join-request-confirmation');
        }, function (error) {
            if (error.response.status === 409) {
                _this.loaderForm = false;
                _this.formHasErrors = true;
                _this.formErrorMessage = 'Join request already exists';
            }
            else {
                _this.$router.push({ name: 'error', params: { code: error.response.status } });
            }
        });
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], TripPilgrimJoinRequestAction.prototype, "tripPilgrim", void 0);
    TripPilgrimJoinRequestAction = __decorate([
        vue_property_decorator_1.Component({
            name: 'TripPilgrimJoinRequestAction'
        })
    ], TripPilgrimJoinRequestAction);
    return TripPilgrimJoinRequestAction;
}(vue_1.default));
exports.default = TripPilgrimJoinRequestAction;
